import { dashboardConstants } from "../_constants";
("use strict");

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import { ajaxError } from "../_actions";
import {
  dashboardAccountHistoryListComplete,
  dashboardAccountHistoryListError,
  dashboardAccountListComplete,
  dashboardAccountListsError,
  dashboardBannerListComplete,
  dashboardBannerListsError,
  dashboardSecureMailNotificationComplete,
  dashboardSecureMailNotificationError,
} from "../_actions/dashboard.actions";

export const dashboardAccountListsEpic = (actions$) =>
  actions$.pipe(
    ofType(dashboardConstants.DASHBOARD_ACCOUNTS_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/getAccountLists",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            dashboardAccountListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(
              dashboardAccountListsError({
                ...error,
                accountType: action.payload.accountType,
              }),
              ajaxError(error),
            ),
          ),
        );
    }),
  );

export const dashboardBannerListsEpic = (actions$) =>
  actions$.pipe(
    ofType(dashboardConstants.DASHBOARD_BANNER_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/dashboard/getBannerLists",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            dashboardBannerListComplete({...ajaxResponse.response, bannerType: (action?.payload?.bannerType || dashboardConstants.BANNER_TYPE_HOME_BANNER)}),
          ),
          catchError((error) =>
            of(dashboardBannerListsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const dashboardAccountHistoryListEpic = (actions$) =>
  actions$.pipe(
    ofType(dashboardConstants.DASHBOARD_ACCOUNT_HISTORY_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/dashboard/getAccountHistoryList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            dashboardAccountHistoryListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(dashboardAccountHistoryListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const dashboardSecureMailNotificationEpic = (actions$) =>
  actions$.pipe(
    ofType(dashboardConstants.DASHBOARD_SECURE_MAIL_NOTIFICATION_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/dashboard/getSecureMailNotification",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            dashboardSecureMailNotificationComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(
              dashboardSecureMailNotificationError(error),
              ajaxError(error),
            ),
          ),
        );
    }),
  );
